// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderExperiment,
    ProviderExperimentClaim,
    ProviderExperimentTemplate,
    SupportCreateExperimentCancelRequestPayload,
    SupportCreateExperimentTemplatePayload,
    SupportExperiment,
    SupportExperimentClaim,
    SupportExperimentRefreshResult,
    SupportExperimentTemplate,
    SupportExperimentUpdatePayload,
    SupportRunExperimentResult,
    SupportRunExperimentTemplatePayload,
    SupportUpdateExperimentTemplatePayload,
    SupportCreateExperimentCancelRequestPayloadToJSON,
    SupportCreateExperimentTemplatePayloadToJSON,
    SupportExperimentUpdatePayloadToJSON,
    SupportRunExperimentTemplatePayloadToJSON,
    SupportUpdateExperimentTemplatePayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderExperimentFromJSON,
    ProviderExperimentClaimFromJSON,
    ProviderExperimentTemplateFromJSON,
    SupportExperimentFromJSON,
    SupportExperimentClaimFromJSON,
    SupportExperimentRefreshResultFromJSON,
    SupportExperimentTemplateFromJSON,
    SupportRunExperimentResultFromJSON,
} from '../models';

export interface GetProviderExperimentRequest {
    id: string;
}

export interface GetProviderExperimentClaimListRequest {
    id: string;
    filterId?: Array<string>;
    filterIsClaimInTheExperiment?: string;
    sort?: Array<GetProviderExperimentClaimListSortEnum>;
    limit?: number;
    offset?: number;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    order?: Array<GetProviderExperimentClaimListOrderEnum>;
}

export interface GetProviderExperimentListRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderExperimentListOrderEnum>;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    sort?: Array<GetProviderExperimentListSortEnum>;
    filterStatus?: Array<string>;
    filterPrimaryPayerId?: Array<string>;
    filterBillingProviderId?: Array<string>;
    filterRenderingProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
}

export interface GetProviderExperimentTemplateRequest {
    id: string;
}

export interface GetSupportExperimentRequest {
    id: string;
}

export interface GetSupportExperimentClaimListRequest {
    id: string;
    filterId?: Array<string>;
    filterActive?: string;
    filterIsClaimInTheExperiment?: string;
    sort?: Array<GetSupportExperimentClaimListSortEnum>;
    limit?: number;
    offset?: number;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    order?: Array<GetSupportExperimentClaimListOrderEnum>;
}

export interface GetSupportExperimentListRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportExperimentListOrderEnum>;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    sort?: Array<GetSupportExperimentListSortEnum>;
    filterActive?: string;
    filterStatus?: Array<string>;
    filterPrimaryPayerId?: Array<string>;
    filterBillingProviderId?: Array<string>;
    filterRenderingProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
}

export interface GetSupportExperimentTemplateRequest {
    id: string;
}

export interface PostExperimentTemplateRequest {
    supportCreateExperimentTemplatePayload: SupportCreateExperimentTemplatePayload;
}

export interface PostSupportApproveExperimentCancelRequestRequest {
    id: string;
}

export interface PostSupportDenyExperimentCancelRequestRequest {
    id: string;
}

export interface PostSupportExperimentCancelRequest {
    id: string;
}

export interface PostSupportExperimentCancelRequestRequest {
    id: string;
    supportCreateExperimentCancelRequestPayload: SupportCreateExperimentCancelRequestPayload;
}

export interface PostSupportExperimentClaimRemoveRequest {
    cid: string;
}

export interface PostSupportExperimentRefreshRequest {
    id: string;
}

export interface PostSupportExperimentTemplateRunRequest {
    supportRunExperimentTemplatePayload: SupportRunExperimentTemplatePayload;
}

export interface PutExperimentTemplateRequest {
    id: string;
    supportUpdateExperimentTemplatePayload: SupportUpdateExperimentTemplatePayload;
}

export interface PutSupportExperimentRequest {
    id: string;
    supportExperimentUpdatePayload: SupportExperimentUpdatePayload;
}

/**
 * no description
 */
export class ExperimentApi extends runtime.BaseAPI {

    /**
     * Get an experiment
     * Get an experiment
     */
    async getProviderExperimentRaw(requestParameters: GetProviderExperimentRequest): Promise<runtime.ApiResponse<ProviderExperiment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderExperiment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:experiment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/experiment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderExperimentFromJSON(jsonValue));
    }

    /**
     * Get an experiment
     * Get an experiment
     */
    async getProviderExperiment(requestParameters: GetProviderExperimentRequest): Promise<ProviderExperiment> {
        const response = await this.getProviderExperimentRaw(requestParameters);
        return await response.value();
    }

    /**
     * A list of records of the claims that were run against an experiment
     * A list of records of the claims that were run against an experiment
     */
    async getProviderExperimentClaimListRaw(requestParameters: GetProviderExperimentClaimListRequest): Promise<runtime.ApiResponse<Array<ProviderExperimentClaim>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderExperimentClaimList.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterIsClaimInTheExperiment !== undefined) {
            queryParameters['filterIsClaimInTheExperiment'] = requestParameters.filterIsClaimInTheExperiment;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:experiment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/experiment/{id}/experiment_claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderExperimentClaimFromJSON));
    }

    /**
     * A list of records of the claims that were run against an experiment
     * A list of records of the claims that were run against an experiment
     */
    async getProviderExperimentClaimList(requestParameters: GetProviderExperimentClaimListRequest): Promise<Array<ProviderExperimentClaim>> {
        const response = await this.getProviderExperimentClaimListRaw(requestParameters);
        return await response.value();
    }

    /**
     * List experiments
     * List experiments
     */
    async getProviderExperimentListRaw(requestParameters: GetProviderExperimentListRequest): Promise<runtime.ApiResponse<Array<ProviderExperiment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterPrimaryPayerId) {
            queryParameters['filterPrimaryPayerId'] = requestParameters.filterPrimaryPayerId;
        }

        if (requestParameters.filterBillingProviderId) {
            queryParameters['filterBillingProviderId'] = requestParameters.filterBillingProviderId;
        }

        if (requestParameters.filterRenderingProviderId) {
            queryParameters['filterRenderingProviderId'] = requestParameters.filterRenderingProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:experiment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/experiment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderExperimentFromJSON));
    }

    /**
     * List experiments
     * List experiments
     */
    async getProviderExperimentList(requestParameters: GetProviderExperimentListRequest): Promise<Array<ProviderExperiment>> {
        const response = await this.getProviderExperimentListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an experiment template
     * Get an experiment template
     */
    async getProviderExperimentTemplateRaw(requestParameters: GetProviderExperimentTemplateRequest): Promise<runtime.ApiResponse<ProviderExperimentTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderExperimentTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:experiment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/experiment/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderExperimentTemplateFromJSON(jsonValue));
    }

    /**
     * Get an experiment template
     * Get an experiment template
     */
    async getProviderExperimentTemplate(requestParameters: GetProviderExperimentTemplateRequest): Promise<ProviderExperimentTemplate> {
        const response = await this.getProviderExperimentTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an experiment
     * Get an experiment
     */
    async getSupportExperimentRaw(requestParameters: GetSupportExperimentRequest): Promise<runtime.ApiResponse<SupportExperiment>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportExperiment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportExperimentFromJSON(jsonValue));
    }

    /**
     * Get an experiment
     * Get an experiment
     */
    async getSupportExperiment(requestParameters: GetSupportExperimentRequest): Promise<SupportExperiment> {
        const response = await this.getSupportExperimentRaw(requestParameters);
        return await response.value();
    }

    /**
     * A list of records of the claims that were run against an experiment
     * A list of records of the claims that were run against an experiment
     */
    async getSupportExperimentClaimListRaw(requestParameters: GetSupportExperimentClaimListRequest): Promise<runtime.ApiResponse<Array<SupportExperimentClaim>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportExperimentClaimList.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterIsClaimInTheExperiment !== undefined) {
            queryParameters['filterIsClaimInTheExperiment'] = requestParameters.filterIsClaimInTheExperiment;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/experiment_claim`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportExperimentClaimFromJSON));
    }

    /**
     * A list of records of the claims that were run against an experiment
     * A list of records of the claims that were run against an experiment
     */
    async getSupportExperimentClaimList(requestParameters: GetSupportExperimentClaimListRequest): Promise<Array<SupportExperimentClaim>> {
        const response = await this.getSupportExperimentClaimListRaw(requestParameters);
        return await response.value();
    }

    /**
     * List experiments
     * List experiments
     */
    async getSupportExperimentListRaw(requestParameters: GetSupportExperimentListRequest): Promise<runtime.ApiResponse<Array<SupportExperiment>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterPrimaryPayerId) {
            queryParameters['filterPrimaryPayerId'] = requestParameters.filterPrimaryPayerId;
        }

        if (requestParameters.filterBillingProviderId) {
            queryParameters['filterBillingProviderId'] = requestParameters.filterBillingProviderId;
        }

        if (requestParameters.filterRenderingProviderId) {
            queryParameters['filterRenderingProviderId'] = requestParameters.filterRenderingProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportExperimentFromJSON));
    }

    /**
     * List experiments
     * List experiments
     */
    async getSupportExperimentList(requestParameters: GetSupportExperimentListRequest): Promise<Array<SupportExperiment>> {
        const response = await this.getSupportExperimentListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an experiment template
     * Get an experiment template
     */
    async getSupportExperimentTemplateRaw(requestParameters: GetSupportExperimentTemplateRequest): Promise<runtime.ApiResponse<SupportExperimentTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportExperimentTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportExperimentTemplateFromJSON(jsonValue));
    }

    /**
     * Get an experiment template
     * Get an experiment template
     */
    async getSupportExperimentTemplate(requestParameters: GetSupportExperimentTemplateRequest): Promise<SupportExperimentTemplate> {
        const response = await this.getSupportExperimentTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an experiment template
     * Create an experiment template
     */
    async postExperimentTemplateRaw(requestParameters: PostExperimentTemplateRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['supportCreateExperimentTemplatePayload'] === null || requestParameters['supportCreateExperimentTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateExperimentTemplatePayload','Required parameter requestParameters.supportCreateExperimentTemplatePayload was null or undefined when calling postExperimentTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateExperimentTemplatePayloadToJSON(requestParameters['supportCreateExperimentTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create an experiment template
     * Create an experiment template
     */
    async postExperimentTemplate(requestParameters: PostExperimentTemplateRequest): Promise<string> {
        const response = await this.postExperimentTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Approve a request to have an experiment canceled
     * Approve a request to have an experiment canceled
     */
    async postSupportApproveExperimentCancelRequestRaw(requestParameters: PostSupportApproveExperimentCancelRequestRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportApproveExperimentCancelRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/cancel_request/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Approve a request to have an experiment canceled
     * Approve a request to have an experiment canceled
     */
    async postSupportApproveExperimentCancelRequest(requestParameters: PostSupportApproveExperimentCancelRequestRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportApproveExperimentCancelRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deny a request to have an experiment canceled
     * Deny a request to have an experiment canceled
     */
    async postSupportDenyExperimentCancelRequestRaw(requestParameters: PostSupportDenyExperimentCancelRequestRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportDenyExperimentCancelRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/cancel_request/deny`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Deny a request to have an experiment canceled
     * Deny a request to have an experiment canceled
     */
    async postSupportDenyExperimentCancelRequest(requestParameters: PostSupportDenyExperimentCancelRequestRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportDenyExperimentCancelRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     * Cancel the given experiment to allow claims to bypass experiment system
     * Allows workers to cancel an experiment without approval flow
     */
    async postSupportExperimentCancelRaw(requestParameters: PostSupportExperimentCancelRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportExperimentCancel.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Cancel the given experiment to allow claims to bypass experiment system
     * Allows workers to cancel an experiment without approval flow
     */
    async postSupportExperimentCancel(requestParameters: PostSupportExperimentCancelRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportExperimentCancelRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a request to have an experiment canceled
     * Create a request to have an experiment canceled
     */
    async postSupportExperimentCancelRequestRaw(requestParameters: PostSupportExperimentCancelRequestRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportExperimentCancelRequest.');
        }

        if (requestParameters['supportCreateExperimentCancelRequestPayload'] === null || requestParameters['supportCreateExperimentCancelRequestPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateExperimentCancelRequestPayload','Required parameter requestParameters.supportCreateExperimentCancelRequestPayload was null or undefined when calling postSupportExperimentCancelRequest.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/cancel_request`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateExperimentCancelRequestPayloadToJSON(requestParameters['supportCreateExperimentCancelRequestPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Create a request to have an experiment canceled
     * Create a request to have an experiment canceled
     */
    async postSupportExperimentCancelRequest(requestParameters: PostSupportExperimentCancelRequestRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportExperimentCancelRequestRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async postSupportExperimentClaimRemoveRaw(requestParameters: PostSupportExperimentClaimRemoveRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['cid'] === null || requestParameters['cid'] === undefined) {
            throw new runtime.RequiredError('cid','Required parameter requestParameters.cid was null or undefined when calling postSupportExperimentClaimRemove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/claim/{cid}/remove`.replace(`{${"cid"}}`, encodeURIComponent(String(requestParameters.cid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     */
    async postSupportExperimentClaimRemove(requestParameters: PostSupportExperimentClaimRemoveRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportExperimentClaimRemoveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Refresh the experiment\'s status, allocations, the responsibility of claims in the experiment, cleaning up abandoned experiment_claims, and moving claims that had relevant data changed from the experiment.
     * Refresh the experiment\'s status, allocations, the responsibility of claims in the experiment, cleaning up abandoned experiment_claims, and moving claims that had relevant data changed from the experiment.
     */
    async postSupportExperimentRefreshRaw(requestParameters: PostSupportExperimentRefreshRequest): Promise<runtime.ApiResponse<SupportExperimentRefreshResult>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportExperimentRefresh.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}/refresh`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportExperimentRefreshResultFromJSON(jsonValue));
    }

    /**
     * Refresh the experiment\'s status, allocations, the responsibility of claims in the experiment, cleaning up abandoned experiment_claims, and moving claims that had relevant data changed from the experiment.
     * Refresh the experiment\'s status, allocations, the responsibility of claims in the experiment, cleaning up abandoned experiment_claims, and moving claims that had relevant data changed from the experiment.
     */
    async postSupportExperimentRefresh(requestParameters: PostSupportExperimentRefreshRequest): Promise<SupportExperimentRefreshResult> {
        const response = await this.postSupportExperimentRefreshRaw(requestParameters);
        return await response.value();
    }

    /**
     * Run an experiment by template name
     * Run an experiment by template name
     */
    async postSupportExperimentTemplateRunRaw(requestParameters: PostSupportExperimentTemplateRunRequest): Promise<runtime.ApiResponse<SupportRunExperimentResult>> {
        if (requestParameters['supportRunExperimentTemplatePayload'] === null || requestParameters['supportRunExperimentTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportRunExperimentTemplatePayload','Required parameter requestParameters.supportRunExperimentTemplatePayload was null or undefined when calling postSupportExperimentTemplateRun.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/run`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportRunExperimentTemplatePayloadToJSON(requestParameters['supportRunExperimentTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportRunExperimentResultFromJSON(jsonValue));
    }

    /**
     * Run an experiment by template name
     * Run an experiment by template name
     */
    async postSupportExperimentTemplateRun(requestParameters: PostSupportExperimentTemplateRunRequest): Promise<SupportRunExperimentResult> {
        const response = await this.postSupportExperimentTemplateRunRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update an experiment template
     * Update an experiment template
     */
    async putExperimentTemplateRaw(requestParameters: PutExperimentTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putExperimentTemplate.');
        }

        if (requestParameters['supportUpdateExperimentTemplatePayload'] === null || requestParameters['supportUpdateExperimentTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateExperimentTemplatePayload','Required parameter requestParameters.supportUpdateExperimentTemplatePayload was null or undefined when calling putExperimentTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateExperimentTemplatePayloadToJSON(requestParameters['supportUpdateExperimentTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update an experiment template
     * Update an experiment template
     */
    async putExperimentTemplate(requestParameters: PutExperimentTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.putExperimentTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update an experiment
     * Update an experiment
     */
    async putSupportExperimentRaw(requestParameters: PutSupportExperimentRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportExperiment.');
        }

        if (requestParameters['supportExperimentUpdatePayload'] === null || requestParameters['supportExperimentUpdatePayload'] === undefined) {
            throw new runtime.RequiredError('supportExperimentUpdatePayload','Required parameter requestParameters.supportExperimentUpdatePayload was null or undefined when calling putSupportExperiment.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/experiment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportExperimentUpdatePayloadToJSON(requestParameters['supportExperimentUpdatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update an experiment
     * Update an experiment
     */
    async putSupportExperiment(requestParameters: PutSupportExperimentRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportExperimentRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetProviderExperimentClaimListSortEnum {
    CREATED = 'CREATED'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderExperimentClaimListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderExperimentListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderExperimentListSortEnum {
    CREATED = 'CREATED',
    STATUS = 'STATUS',
    PRIMARYPAYERID = 'PRIMARY_PAYER_ID',
    BILLINGPROVIDERID = 'BILLING_PROVIDER_ID',
    RENDERINGPROVIDERID = 'RENDERING_PROVIDER_ID',
    FACILITYID = 'FACILITY_ID',
    FROMDOS = 'FROM_DOS',
    THROUGHDOS = 'THROUGH_DOS'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportExperimentClaimListSortEnum {
    CREATED = 'CREATED'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportExperimentClaimListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportExperimentListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportExperimentListSortEnum {
    CREATED = 'CREATED',
    STATUS = 'STATUS',
    PRIMARYPAYERID = 'PRIMARY_PAYER_ID',
    BILLINGPROVIDERID = 'BILLING_PROVIDER_ID',
    RENDERINGPROVIDERID = 'RENDERING_PROVIDER_ID',
    FACILITYID = 'FACILITY_ID',
    FROMDOS = 'FROM_DOS',
    THROUGHDOS = 'THROUGH_DOS'
}
